import HistoryPrice from "./HistoryPrice";
export default HistoryPrice;
